
function addItemToCartProduct(variant_id, e) {
  console.log(variant_id);
    data = {
        "id": variant_id,
        "quantity": 1
    }
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: async function (response) {
            let cartContent = response;
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
            }));
        }, error: function (request, error) {
            console.log(arguments);
            document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
                bubbles: true,
                detail: {
                    error: arguments[0].responseText
                }
            }));
            if (arguments[0].status == 422) {
                console.log(" Can't do because: " + arguments[0].responseJSON.description);
                e.target.closest('.product-card-content').querySelector('.cartErrorMsg');
                let getErrorMsgDiv = e.target.closest('.product-card-content').querySelector('.cartErrorMsg');
                console.log("getErrorMsgDiv--->", getErrorMsgDiv);
                if (getErrorMsgDiv) {
                    getErrorMsgDiv.innerText = arguments[0].responseJSON.description;
                    setTimeout(() => {
                        getErrorMsgDiv.innerText = ''
                    }, 700)
                }
            }
        }
    });
}


document.addEventListener('click', async function (e) {
    // Check if the clicked element is a size-val or inside a size-val
    const sizeValElement = e.target.closest('.size-val');
    if (!sizeValElement) return; // Exit if the click is not on a size-val element

    e.preventDefault();

    // Get the variant ID from the value attribute of the size-val element
    const variantId = sizeValElement.getAttribute('value');
    if (!variantId) {
        console.warn("Variant ID not found on the selected size-val element.");
        return;
    }

    // Show a loader inside the clicked element
    const originalContent = sizeValElement.innerHTML;
    sizeValElement.innerHTML = `<div class="loader-layout"></div>`;

    try {
        // Add the item to the cart
        await addItemToCartProduct(variantId, e);
    } catch (error) {
        console.error("Error adding item to cart:", error);
    } finally {
        // Restore the original content of the size-val element
        setTimeout(() => {
            sizeValElement.innerHTML = originalContent;
        }, 1000);
    }
});

